import queryString from "query-string";

import { CHECKPOINT } from "constants/actionTypes";

import { serializeCheckpoint } from "lib/serializers/checkpoints";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const urlCreator = ({ changesSince, livestockSaleId, id, action } = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/checkpoints/", id, action),
    query: {
      livestock_sale_id: livestockSaleId,
      changesSince,
    },
  });

export const CheckpointAction = offlineActionCreator(
  CHECKPOINT,
  serializeCheckpoint,
  urlCreator,
  true,
);
